import React, { Component } from 'react'
import "./policySearchInfo.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { Pagination } from 'antd';
import 'antd/dist/antd.css';
import { UrlSearch } from '../../axios/localstorage';
import { getApiPolicyPDetail , getApiNewsListByProjectIds } from '../../axios/api';

export default class policySearchInfo extends Component {

    state = {
        type:0,
        page:1,
        total:1,
        data:{},
        newsList:[],
        arr:[],
    }

    componentWillMount(){
        window.scroll(0,0);

        let id = UrlSearch('id');

        this.getInfo(id)

        getApiNewsListByProjectIds({id})
        .then( req =>{
            if(req.data.code === 1){
                let arr = req.data.data;
                this.setState({arr})
            }
        }).catch( err =>{
            console.error(err);
        })

    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    changePage=(page)=>{
        this.setState({
            page
        })

    }

    getInfo=(id)=>{
        let param = {
            id
        }

        getApiPolicyPDetail(param)
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    data,
                    newsList:data.newsList
                })

            }
        }).catch( err =>{
            console.error(err);
        })
    }

    render() {
        return (
            <div className='policySearchInfo'>
                <Header type={2} />
                <div className='cen'>
                    <div className='main'>
                        <div className='name'>
                            <p>当前位置：</p>
                            <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p className='i_point' onClick={()=>{this.gotoPage('/policySearch')}}>政策查询</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p>政策详情</p>
                        </div>

                        <div className='box'>
                            <div className='left'>
                                <div className='top'>
                                    <h2>{this.state.data.title}</h2>
                                    <div className='text'>
                                        <div>
                                            <p>项目来源：{this.state.data.announcements}</p>
                                            <p>项目标签：{this.state.data.partition}</p>
                                            <p>申报时间：{this.state.data.startTime} —— {this.state.data.endTime}</p>
                                        </div>
                                    </div>
                                    <button className='green' hidden={this.state.data.countDown === '待定'}>{this.state.data.countDown}天</button>
                                    <button hidden={this.state.data.countDown !== '待定'}>待定</button>
                                </div>
                                <div className='ptype'>
                                    <div className='pflex'>
                                        <div onClick={()=>{this.setState({type:0})}} className={this.state.type === 0?'pfi pf_active':"pfi"} style={this.state.type === 0?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                            <p>政策简读</p>
                                        </div>
                                        <div onClick={()=>{this.setState({type:1})}} className={this.state.type === 1?'pfi pf_active':"pfi"} style={this.state.type === 1?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                            <p>资助历史</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='lbox' hidden={this.state.type !== 0}>
                                    <div className='name'>
                                        <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                        <h2>适用产业</h2>
                                    </div>

                                    <div className="cont" dangerouslySetInnerHTML={{
                                        __html: this.state.data.industries
                                    }}></div>

                                    <div className='name'>
                                        <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                        <h2>申请条件</h2>
                                    </div>
                                    
                                    <div className="cont" dangerouslySetInnerHTML={{
                                        __html: this.state.data.condition
                                    }}></div>
                                    <div className='name'>
                                        <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                        <h2>支持力度</h2>
                                    </div>
                                    <div className="cont" dangerouslySetInnerHTML={{
                                        __html: this.state.data.support
                                    }}></div>
                                    <div className='name'>
                                        <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                        <h2>申报材料</h2>
                                    </div>
                                    <div className="cont" dangerouslySetInnerHTML={{
                                        __html: this.state.data.materials
                                    }}></div>
                                    <div className='name'>
                                        <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                        <h2>项目来源</h2>
                                    </div>
                                    <div className="cont" dangerouslySetInnerHTML={{
                                        __html: this.state.data.announcements
                                    }}></div>
                                </div>

                                <div className='lbox' hidden={this.state.type !== 1}>
                                    <table>
                                        <thead>
                                            <tr className='trh'>
                                                <th className='tfd'>资助历史</th>
                                                <th>发布时间</th>
                                            </tr>
                                            <tr className='trh2'>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        
                                        <tbody>
                                            {
                                                this.state.arr.map((item,index)=>{
                                                    return <tr >
                                                                <td className='tfd'>{item.title}</td>
                                                                <td>{item.publishTime}</td>
                                                            </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    {/* <div className='r_page'>
                                        <Pagination type="success" showSizeChanger={false} pageSize={10}  defaultCurrent={this.state.page} total={this.state.total} onChange={(page)=>{this.changePage(page)}} />
                                    </div>     */}
                                </div>
                            </div>
                            <div className='right'>
                                <div className='rbox'>
                                    <div className='rname'>
                                        <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                        <p>相关政策</p>
                                    </div>
                                    <div className='text'>
                                        {
                                            this.state.newsList.map((item,index)=>{
                                                return <p key={index} onClick={()=>{this.gotoPage('/policyinfo?id='+item.id)}}>{item.title}</p>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
